module.exports = __webpack_public_path__ + "img/card-key-features.aa680647.png";